<app-tooltip-template label="admin.users.email" *ngIf="params.email">
  {{ params.email }}
</app-tooltip-template>
